import React from 'react'

import { graphql, useStaticQuery } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import { Grid } from '@material-ui/core'

import MainLayout from '../layouts/MainLayout/MainLayout'

import SEO from '../components/Seo/Seo'

import Contact from '../components/Contact/Contact'

const getContact = graphql`
  query getContact {
    contentfulInformation(title: { eq: "Contact Page" }) {
      content {
        json
      }
    }
  }
`

const ContactPage = () => {
  const data = useStaticQuery(getContact)
  return (
    <MainLayout>
      <SEO title="Contact" />
      <div className="navClear"></div>
      <Grid container className="bgWhite" alignItems="center" justify="center">
        <Grid item xs={12} md={10} lg={8}>
          <h3>Contact Us</h3>
          {documentToReactComponents(data.contentfulInformation.content.json)}
        </Grid>
      </Grid>

      <Contact />
    </MainLayout>
  )
}

export default ContactPage
